exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".resetBtn {\n  margin-top: 5px; }\n\n.remove-link-btn-pad {\n  padding: 0px !important; }\n\n.searchBox-bg-color {\n  background-color: #ededed !important; }\n\n.vault-close-search-dd .multiSelect .checkboxLayer {\n  display: inline-block;\n  max-height: 350px !important;\n  overflow-y: auto !important;\n  width: 20% !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/vault_close/vault_close.scss
// module id = 1192
// module chunks = 1